<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add Level</h4>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Level</label>
          <input class="form-control" [(ngModel)]="level" placeholder="1" type="number">
        </div>
        <div class="form-group mb-3">
          <label>XP Required for next level</label>
          <input class="form-control" [(ngModel)]="nextLevelExperienceRequired" placeholder="0" type="number">
        </div>
        <div class="form-group mb-3">
          <label>Next level reward</label>
          <input class="form-control" [(ngModel)]="nextLevelReward" placeholder="0" type="number">
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
          Add
        </button>
      </div>
    </div>
  </div>
</div>
